// VAPT TRT-04: media in rich text may only load from our own hosts. External src values act as
// tracking pixels (leak viewer IPs) and let a third party swap published content after approval.
const ALLOWED_MEDIA_HOSTS = [
  window.__RUNTIME_CONFIG__?.REACT_APP_API_URL,
  window.__RUNTIME_CONFIG__?.REACT_APP_BASE_URL,
  window.__RUNTIME_CONFIG__?.REACT_FRONTEND_BASE_URL,
  window.location.origin,
]
  .map((url) => {
    try {
      return new URL(url).host
    } catch {
      return null
    }
  })
  .filter(Boolean)

const MEDIA_TAGS = ['img', 'video', 'audio', 'source', 'track']

export const isAllowedMediaSrc = (src = '') => {
  // relative paths, data: and blob: URIs never reach a third-party host
  if (!/^(https?:)?\/\//i.test(src.trim())) return true
  try {
    return ALLOWED_MEDIA_HOSTS.includes(new URL(src.trim(), window.location.href).host)
  } catch {
    return false
  }
}

export const stripExternalMedia = (editor: any) => (nodes: any[]) => {
  let removed = 0
  nodes.forEach((node) => {
    if (MEDIA_TAGS.includes(node.name) && !isAllowedMediaSrc(node.attr('src'))) {
      node.remove()
      removed++
    }
  })
  if (removed) {
    editor.notificationManager.open({
      text: 'External images/media were removed. Please upload files through the Media Manager.',
      type: 'warning',
      timeout: 6000,
    })
  }
}
